<template>

    <footer>
        <div class="container">
            <div class="content">
                <div class="pwr">
                    <div class="lft">
                        <span class="dots"></span>
                    </div>
                    <div class="rgt">
                        <span class="caption ft-xbld txt-grt">Powered by</span>
                        <span class="name"></span>
                    </div>
                </div>
                <p class="cr ft-bld">
                    <span>© 2022 Alpha Networks. All rights reserved worldwide</span>
                    <span class="spr">|</span>
                    <span class="txt-grt">Privacy Policy</span>
                </p>
            </div>
        </div>
    </footer>

</template>

<script>

    export default {

        name: 'Footbar',

        data() {
            return {

            }
        }

    }

</script>